<template>
	<p v-html="html" class="system-message"></p>
</template>

<script>
	import { textReplaceLink } from '@/utils/functions'
	export default {
		props:{
			content: {
				require:true
			},
		},
		watch:{
			'content':{
				handler(val){
					 this.html = textReplaceLink(val)
				},
				immediate:true
			}
		},
		data(){
			return{
				html:''
			}
		}
	}
</script>

<style lang="scss" scoped>
	.system-message {
		width: 80%;
		padding: 10px 20px;
		background: #BDBDBD;
		border-radius: 3px;
		margin: 10px auto;
		color: #F2F8FF;
		text-align: center;
		overflow-wrap: break-word;
	}
</style>
